module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-1-04b4a82f.png";